module.exports = __webpack_public_path__ + "assets/8a68aecf32e49ae01707cbacd60bc992.png";